/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "../actions/actionTypes";

// initialState
const initialState = {
  isGeometrySaved: false,
  showUserInfoBox: false,
  showInfoWindow: false,
  jobType: "",
  user: {
    userId: "",
    name: "",
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //  update the info window checkbox status in geofence
    case actionTypes.UPDATE_INFO_WINDOW_CHECKBOX:
      return {
        ...state,
        showInfoWindow: action.isChecked,
      };

    // update the work order assigned user checkbox status in geofence
    case actionTypes.UPDATE_WORK_ORDER_USER_INFO_BOX_CHECKBOX:
      return {
        ...state,
        showUserInfoBox: action.isChecked,
      };

    // update the selected job filter value
    case actionTypes.UPDATE_JOB_TYPE_FILTER:
      return {
        ...state,
        jobType: action.jobType,
      };

    // update the selected user filter value
    case actionTypes.UPDATE_USER_FILTER:
      return {
        ...state,
        user: action.user,
      };

    // update when created/updated geofence is saved or not
    case actionTypes.SET_PATH_SAVE_STATUS:
      return {
        ...state,
        isGeometrySaved: action.status,
      };

    default:
      return state;
  }
};

export default reducer;
